/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ─────────────────────────────────────────────────────────────
   Theatre House — accessibility helpers (live axe round-2: A3 + A4)
   A4 (link-name): give links with no discernible text an accessible name.
   A3 (aria-hidden-focus): keep focusables inside aria-hidden subtrees
   (off-screen carousel cells, closed drawers) out of the tab order, and
   restore them when the subtree becomes visible. Reacts to Flickity /
   drawers toggling aria-hidden via a MutationObserver.
   ───────────────────────────────────────────────────────────── */
(function () {
  var FOCUSABLE = 'a[href],button,input,select,textarea,[tabindex]';

  function nameLinks(root) {
    (root || document).querySelectorAll('a[href]:not([data-th-named])').forEach(function (a) {
      a.setAttribute('data-th-named', '');
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt || a.getAttribute('aria-label') || a.getAttribute('aria-labelledby') || a.getAttribute('title')) return;
      var img = a.querySelector('img[alt]');
      if (img && (img.getAttribute('alt') || '').trim()) return;        // meaningful image alt already names the link
      if (a.querySelector('[aria-label],[aria-labelledby],svg title')) return;
      var href = a.getAttribute('href') || '';
      var label = /\.pdf(\?|#|$)/i.test(href) ? 'Download PDF' : 'Link';
      if (a.getAttribute('target') === '_blank') label += ' (opens in a new tab)';
      a.setAttribute('aria-label', label);
    });
  }

  function syncHidden(root) {
    var scope = root || document;
    scope.querySelectorAll('[aria-hidden="true"]').forEach(function (h) {
      h.querySelectorAll(FOCUSABLE).forEach(function (f) {
        if (!f.hasAttribute('data-th-ti')) f.setAttribute('data-th-ti', f.getAttribute('tabindex') || '');
        if (f.getAttribute('tabindex') !== '-1') f.setAttribute('tabindex', '-1');
      });
    });
    scope.querySelectorAll('[data-th-ti]').forEach(function (f) {
      if (f.closest('[aria-hidden="true"]')) return;                    // still hidden — leave it
      var prev = f.getAttribute('data-th-ti');
      if (prev === '') f.removeAttribute('tabindex'); else f.setAttribute('tabindex', prev);
      f.removeAttribute('data-th-ti');
    });
  }

  function run() { nameLinks(); syncHidden(); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  var scheduled = false;
  var obs = new MutationObserver(function (muts) {
    var need = false;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type === 'attributes' && muts[i].attributeName === 'aria-hidden') { need = true; break; }
      if (muts[i].type === 'childList' && muts[i].addedNodes.length) { need = true; break; }
    }
    if (need && !scheduled) {
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; run(); });
    }
  });
  obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });

  // Related/recommendation carousels load via AJAX AFTER DOMContentLoaded, and
  // Flickity sets aria-hidden on off-screen cells asynchronously (imagesLoaded /
  // resize), which can land after the observer's first sweep. Re-sweep on load,
  // on a few settle delays, and (for lazy on-scroll carousels) on scroll.
  window.addEventListener('load', run);
  [400, 1200, 2500, 4000].forEach(function (d) { setTimeout(run, d); });
  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; run(); }, 400);
  }, { passive: true });
})();

